<template>
  <div>
    <div class="main">
      <Header/>
      <div class="desc">
        正在下载，如长时间不跳转，请 <a @click="onRequest">点击重试</a><br/>
        遇到问题请点击在线客服联系人工客服
      </div>
    </div>
    <div style="position: absolute;z-index: 3000">
      <ContactUs/>
    </div>
  </div>
</template>


<script>
import Header from '@/components/Header';
import OpenInstall from '../lib/OpenInstall';
import {Loading} from "element-ui";
import axios from "axios";
import ContactUs from "@/components/contact-us.vue";

export default {
  name: "open",
  components: {
    ContactUs,
    Header,
  },
  data() {
    return {};
  },
  created() {
    // 如果存在邀请码就复制邀请码
    let inviteCode = this.$route.query.invitationCode;
    if (inviteCode) this.$copyText(inviteCode.toString());
    this.onRequest();
  },
  methods: {
    onRequest() {
      // 是否是IOS
      const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      // 请求接口获得下载信息
      let configLoadingInstance = Loading.service({});
      axios.post("/api/system/system/web/download-info", {"type": isiOS ? 1 : 0}).then((res) => {
        if (res.code !== 200) return;
        let data = res.data;

        // 如果未启用下载
        if (!data.enabled) {
          alert(data.disabledTips);
          let search = location.search;
          if(!location.search) search = "?1=1";
          location.href = "/download/index.html" + search;
          return;
        }

        // 如果存在跳转，则跳转到指定路径
        if(data.jump){
          this.$router.push({path: data.jump, query: this.$route.query});
          return;
        }

        // 打开下载页面
        OpenInstall.install();
      }).finally(() => configLoadingInstance.close());
    },
  }
}
</script>
<style scoped>
.desc {
  padding: 20px;
}

.desc a {
  color: cornflowerblue;
}
</style>
